// Carting agents (transporters) are fixed per vendor and unrelated to any one material's rate — a
// vendor's rate is the same no matter which of its regular transporters actually delivers a load.
import { vendorKey } from './materialReceiving';

const normalize = (value: string) => value.trim().toLowerCase().replace(/\s+/g, ' ');

/** This vendor's saved carting agents, alphabetical. */
export const cartingAgentsFor = (agentsByVendor: Record<string, string[]>, vendorName: string): string[] =>
  [...(agentsByVendor[vendorKey(vendorName)] || [])].sort((a, b) => a.localeCompare(b));

/** Adds a carting agent to a vendor's list, deduplicated case/spacing-insensitively. Blank is a no-op. */
export function planCartingAgents(existing: string[], name: string): string[] {
  const trimmed = name.trim();
  if (!trimmed || existing.some((agent) => normalize(agent) === normalize(trimmed))) return existing;
  return [...existing, trimmed];
}

/** Removes a carting agent by name (case/spacing-insensitive); leaves the list unchanged if not found. */
export function removeCartingAgent(existing: string[], name: string): string[] {
  return existing.filter((agent) => normalize(agent) !== normalize(name));
}
